
import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Avatar } from 'primereact/avatar';
import logo_damine from '../../images/logo_damine.png'
import logo from '../../images/logo.png'
import { ProgressBar } from 'primereact/progressbar';
import '../../styles/pages/components/Title.css';

type Props = {
    titulo: string;
    user: any;
    loading?: boolean;
    progress?: number;
}

export default function CustomToolbar(props: Props) {
    const startContent = (
        <React.Fragment>
            {/* <MonitoraBahiaIcon style={{ width: '32px', height: '32px', marginRight: '10px' }} /> */}
            <div className="flex align-items-center gap-2">
                <Avatar image={logo} shape="circle" />
            </div>
        </React.Fragment>
    );

    const centerContent = (
        <div className="flex flex-wrap " style={{ width: '100%' }}>
            <span style={{ color: 'white', fontSize: 20, fontWeight: 'bold' }}>{props.titulo}</span><br></br>
        </div>
    );

    const endContent = (
        <React.Fragment>
            <div className="flex align-items-center gap-2">
                <Avatar image={logo_damine} shape="circle" />
            </div>
        </React.Fragment>
    );
    const access = props.user?.groups?.[0]?.name || 'INDEFINIDO'
    const name = props.user?.pessoa?.nome_razao ||  '' 
    //console.log('Access CustomToolbar', access)
    return (
        <div className='titulo'>
            <div className="card" style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', }}>
                <Toolbar start={startContent} center={centerContent} end={endContent} className="bg-gray-900 shadow-2" style={{ width: 600, borderRadius: '3rem', backgroundImage: 'linear-gradient(to right, var(--bluegray-500), var(--bluegray-800))' }} />
                     <p style={{ borderRadius: 10, width: 500, marginTop: 0, backgroundColor: 'black', color: 'gray', fontSize: 8 }}>{name.toUpperCase()} - NÍVEL DE ACESSO: [{access.toUpperCase()}
                        {/* {access==='Fiscal ADAB'?
                            <FiscalIcon style={{paddingTop: -50, marginTop: -50}} color='white' height={8} />:
                        (access==='Supervisor AIBA'?
                            <SupervisorAibaIcon />:
                        (access==='Fiscal PROALBA'?
                            <SupervisorProAlbaIcon />:
                        (access==='Produtor'?
                            <ProdutorIcon />:
                            <></>)))}*/}
                        ]</p>
                {props.loading && <ProgressBar mode="indeterminate" color='#333333' style={{ marginTop: '0px', marginLeft: '35px', marginRight: '35px', height: '3px' }}></ProgressBar>}
                {props.progress && (props.progress < 1) && <ProgressBar value={props.progress * 100} color='#333333' style={{ marginTop: '-4px', marginLeft: '33px', marginRight: '33px', height: '3px' }}></ProgressBar>}
            </div>
        </div>
    );
}
